module.exports = __webpack_public_path__ + "img/500-bg-left.0814269.png";